import React from "react"
import { AppNote } from "@components"
import { DS_REPRICING_ROUTES } from "@constants/routes"
import { includeProviders, repricingPass } from "@signals"
import { passDecisions, responseData, showPassDecisions, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { hiddenCount } from "../columns/Data/@services/cellDecisions"
import { cellPlace, decisionsIndex } from "../columns/Data/@hooks/useCellDecisions"

// The cells the table draws: site, provider, date, length
function visibleCells() {
	const rows = responseData.value?.[tableTabSelected.value === 'max_price' ? 'tableDataMax' : 'tableDataMin'] || []
	const keys = []
	for (const row of rows) {
		for (const value of Object.values(row || {})) {
			const priceData = value?.price_data
			if (!priceData || typeof priceData !== 'object') continue
			const place = cellPlace(priceData)
			if (place.site == null) continue
			keys.push(place)
		}
	}
	return keys
}

// "N repricing decisions sit on rows your filters hide" (UX Obs. 17): a decision never disappears without saying so
export default function DecisionsNote() {
	if (!repricingPass.value || !showPassDecisions.value || !passDecisions.value?.cells) return null
	if (passDecisions.value.error) return <AppNote severity="warning" sx={{ mt: 1 }}>The repricing decisions could not be loaded; the prices are complete.</AppNote>
	const cells = visibleCells()
	const hidden = hiddenCount(decisionsIndex(), cells, { byProvider: !!includeProviders.value })
	if (!hidden) return null
	return <AppNote severity="info" sx={{ mt: 1 }}>
		{hidden} repricing {hidden === 1 ? 'decision sits' : 'decisions sit'} on your own rows that the table does not show (filtered out, no own offer, or no own sites or brands set in Settings). <a href={`${DS_REPRICING_ROUTES.ACTIVITY_PATH}?execution_id=${encodeURIComponent(repricingPass.value)}`} target="_blank" rel="noopener noreferrer">Show in Activity</a>
	</AppNote>
}
